import { stat } from 'fs';
import {

    GET_GLOBAL_ILINK_FIRMWARE_REQUEST,
    GET_GLOBAL_ILINK_FIRMWARE_SUCCESS,
    GET_GLOBAL_ILINK_FIRMWARE_FAILURE,

    GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_REQUEST,
    GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_SUCCESS,
    GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_FAILURE,

    POST_GLOBAL_ILINK_FIRMWARE_REQUEST,
    POST_GLOBAL_ILINK_FIRMWARE_SUCCESS,
    POST_GLOBAL_ILINK_FIRMWARE_FAILURE,

    SET_SELECTED_MODEMS,
    SET_SELECTED_FIRMWARE_VERSION

} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    error: null,
    modems: [],
    firmwareVersion: null,
    firmwareVersions: [],
    message: undefined,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_GLOBAL_ILINK_FIRMWARE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_GLOBAL_ILINK_FIRMWARE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modems: action.payload.modems,
                isInitialFetch: false,
            };
        case GET_GLOBAL_ILINK_FIRMWARE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_SUCCESS:
            var fv = (!state.firmwareVersion && action.payload.firmwareVersions.length) ?
                action.payload.firmwareVersions[0]?.firmwareVersion : state.firmwareVersion;
            return {
                ...state,
                isLoading: false,
                firmwareVersions: action.payload.firmwareVersions,
                firmwareVersion: fv,
                isInitialFetch: false,
            };
        case GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };


        case POST_GLOBAL_ILINK_FIRMWARE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case POST_GLOBAL_ILINK_FIRMWARE_SUCCESS:
            const modems = state.modems?.map((d) => ({
                ...d,
                isSelected: false,
            }))
            return {
                ...state,
                isLoading: false,
                message: action.payload.message,
                modems: modems,
                isInitialFetch: false,
            };
        case POST_GLOBAL_ILINK_FIRMWARE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.message || action.payload?.error?.message,
            };

        case SET_SELECTED_MODEMS:
            return {
                ...state,
                modems: state.modems.map((m) => {
                    if (m.modemId === action.payload.id) {
                        return {
                            ...m,
                            isSelected: action.payload.isSelected
                        }
                    }
                    return m;
                }),
            };

        case SET_SELECTED_FIRMWARE_VERSION:
            return {
                ...state,
                firmwareVersion: action.payload.firmwareVersion,
            };

        default:
            return state;
    }
};